import { configureStore } from '@reduxjs/toolkit'
import stlSlicer from '../features/stlSlicer'
export const store = configureStore({
  reducer: {
    stlSlicer: stlSlicer,
  },
})
